import React, { useEffect, useRef, useState } from 'react'
import './Services.scss'
import ServicesWidget from 'src/components/ServicesWidget'
import PageHero from 'src/components/PageHero'


const Services = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const root = document.getElementById('root')
  root.classList.add('black-bck')
  const sectionDescriptionString = `At ${companyName}, we have the expertise and resources to deliver your software needs.`

  useEffect(() => {
    document.title = companyName + ' - Services'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", `At ${companyName}, we have the expertise and resources to deliver your software needs.`)
    }
  }, [])


  return (
    <>
      <PageHero sectionTitle="Services" sectionDescription={sectionDescriptionString} />
      <section className='services-widget black-bck'>
        <ServicesWidget />
      </section>
    </>
  )
}

export default Services